import _extends from '@babel/runtime-corejs3/helpers/extends';
import React__default from 'react';
import classNames from 'classnames';
import menuStyles from '../NewMenu.js';
import '../../../icons/index.es.js';
import { useInputGroupContext } from '../../InputGroup/InputGroupProvider.js';
import { useFormFieldControl } from '../../FormField/FormFieldContext.js';
import '../../../utils/index.js';
import concatIds from '../../../utils/concatIds/concatIds.js';
import ChevronDownIcon from '../../../icons/components/ChevronDownIcon.js';

const MenuAnchor = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    label,
    className,
    small,
    isOpen,
    disabled,
    onClick,
    onKeyDown,
    'aria-describedby': externalAriaDescribedBy,
    ...rest
  } = _ref;
  const inputGroupContext = useInputGroupContext();
  const {
    hasLabel: hasFormLabel,
    helperTextId: formFieldHelperTextId,
    errorTextId: formFieldErrorTextId
  } = useFormFieldControl();
  const internalAriaDescribedby = concatIds(externalAriaDescribedBy, formFieldHelperTextId, formFieldErrorTextId);
  return /*#__PURE__*/React__default.createElement("button", _extends({}, rest, {
    ref: ref,
    type: "button",
    className: classNames(className, menuStyles.menuBtn, inputGroupContext.className, {
      [menuStyles.unlabelledButton]: !label && label !== 0,
      [menuStyles.small]: inputGroupContext.applySmall(small),
      [menuStyles.formLabelled]: hasFormLabel
    }),
    "aria-haspopup": "menu",
    "aria-disabled": disabled,
    "aria-describedby": internalAriaDescribedby,
    onClick: disabled ? undefined : onClick,
    onKeyDown: disabled ? undefined : onKeyDown
  }), /*#__PURE__*/React__default.createElement("span", {
    className: menuStyles.menuBtnLabel
  }, label), /*#__PURE__*/React__default.createElement(ChevronDownIcon, {
    className: classNames(menuStyles.rightIcon, {
      [menuStyles.small]: inputGroupContext.applySmall(small),
      [menuStyles.open]: isOpen
    }),
    "aria-hidden": "true"
  }));
});

export { MenuAnchor as default };
